module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard', {
    attrs: {
      "charts": _vm.charts,
      "filters": _vm.filters,
      "results": _vm.search,
      "savedQueries": _vm.savedQueries,
      "mode": _vm.mode,
      "loadingSavedQueries": this.$apollo.queries.savedQueries.loading,
      "loadingCharts": this.$apollo.queries.charts.loading,
      "loadingFilters": this.$apollo.queries.filters.loading,
      "loadingPlugins": this.$apollo.queries.plugins.loading,
      "searching": this.$apollo.queries.search.loading
    },
    on: {
      "download": _vm.handleDownload,
      "filter": _vm.handleFilter,
      "display-profiles": _vm.handleDisplayProfiles,
      "load-more-profiles": _vm.handleLoadMoreProfiles,
      "save-query": _vm.handleSaveQuery,
      "delete-query": _vm.handleDeleteQuery
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-144f3ac3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/profile/ProfilesDashboardContainer.vue
// module id = 3146
// module chunks = 3